var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 9.5a6 6 0 1 1 12 0v5.651l.084.126 1.832 2.748a.5.5 0 0 1 .084.278v.197a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.197a.5.5 0 0 1 .084-.278l1.832-2.748.084-.126V9.5m5.002-6.93L11 2.5a1 1 0 1 1 1.998.07A7 7 0 0 1 19 9.5v5.349l1.748 2.622a1.5 1.5 0 0 1 .252.832v.197a1.5 1.5 0 0 1-1.5 1.5h-4.541a3 3 0 0 1-5.918 0H4.5A1.5 1.5 0 0 1 3 18.5v-.197a1.5 1.5 0 0 1 .252-.832L5 14.849V9.5a7 7 0 0 1 6.002-6.93M10.063 20a2 2 0 0 0 3.874 0z",
    clipRule: "evenodd"
  })));
});
const SvgBell = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDkuNUM2IDYuMTg2MjkgOC42ODYyOSAzLjUgMTIgMy41QzE1LjMxMzcgMy41IDE4IDYuMTg2MjkgMTggOS41VjE1VjE1LjE1MTRMMTguMDg0IDE1LjI3NzNMMTkuOTE2IDE4LjAyNTRDMTkuOTcwOCAxOC4xMDc2IDIwIDE4LjIwNDEgMjAgMTguMzAyOFYxOC41QzIwIDE4Ljc3NjEgMTkuNzc2MSAxOSAxOS41IDE5SDE0LjVIOS41SDQuNUM0LjIyMzg2IDE5IDQgMTguNzc2MSA0IDE4LjVWMTguMzAyOEM0IDE4LjIwNDEgNC4wMjkyMiAxOC4xMDc2IDQuMDgzOTcgMTguMDI1NEw1LjkxNjAzIDE1LjI3NzNMNiAxNS4xNTE0VjE1VjkuNVpNMTEuMDAyNCAyLjU3MDU0QzExLjAwMDggMi41NDcyNCAxMSAyLjUyMzcyIDExIDIuNUMxMSAxLjk0NzcyIDExLjQ0NzcgMS41IDEyIDEuNUMxMi41NTIzIDEuNSAxMyAxLjk0NzcyIDEzIDIuNUMxMyAyLjUyMzcyIDEyLjk5OTIgMi41NDcyNCAxMi45OTc2IDIuNTcwNTRDMTYuMzkxIDMuMDU0NzIgMTkgNS45NzI2OCAxOSA5LjVWMTQuODQ4NkwyMC43NDgxIDE3LjQ3MDdDMjAuOTEyMyAxNy43MTcxIDIxIDE4LjAwNjYgMjEgMTguMzAyOFYxOC41QzIxIDE5LjMyODQgMjAuMzI4NCAyMCAxOS41IDIwSDE0Ljk1ODVDMTQuNzIwNSAyMS40MTg5IDEzLjQ4NjUgMjIuNSAxMiAyMi41QzEwLjUxMzUgMjIuNSA5LjI3OTUyIDIxLjQxODkgOS4wNDE0OCAyMEg0LjVDMy42NzE1NyAyMCAzIDE5LjMyODQgMyAxOC41VjE4LjMwMjhDMyAxOC4wMDY2IDMuMDg3NjYgMTcuNzE3MSAzLjI1MTkyIDE3LjQ3MDdMNSAxNC44NDg2VjkuNUM1IDUuOTcyNjggNy42MDg5NiAzLjA1NDcyIDExLjAwMjQgMi41NzA1NFpNMTAuMDYzIDIwQzEwLjI4NSAyMC44NjI2IDExLjA2ODEgMjEuNSAxMiAyMS41QzEyLjkzMTkgMjEuNSAxMy43MTUgMjAuODYyNiAxMy45MzcgMjBIMTAuMDYzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";